/** Copied from graphql-global-types, I didn't know how to solve this loader issue */

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum ColumnType {
  AUTO_NUMBER = 'AUTO_NUMBER',
  CHECKBOX = 'CHECKBOX',
  COLLABORATOR = 'COLLABORATOR',
  CREATED_AT = 'CREATED_AT',
  CREATED_BY = 'CREATED_BY',
  CURRENCY = 'CURRENCY',
  DATETIME = 'DATETIME',
  EMAIL = 'EMAIL',
  FORMULA = 'FORMULA',
  INTEGRATION_REFERENCE = 'INTEGRATION_REFERENCE',
  LONG_TEXT = 'LONG_TEXT',
  LOOKUP = 'LOOKUP',
  MULTI_ATTACHMENT = 'MULTI_ATTACHMENT',
  MULTI_SELECT = 'MULTI_SELECT',
  NOOP = 'NOOP',
  NUMBER = 'NUMBER',
  PHONE = 'PHONE',
  RATING = 'RATING',
  RECORD_REFERENCE = 'RECORD_REFERENCE',
  ROLLUP = 'ROLLUP',
  SELECT = 'SELECT',
  STATUS = 'STATUS',
  TEXT = 'TEXT',
  UNIQUE_ID = 'UNIQUE_ID',
  SUBTABLE='SUBTABLE'
}

export enum EntityRole {
  ADMIN = 'ADMIN',
  COMMENTER = 'COMMENTER',
  EDITOR = 'EDITOR',
  VIEWER = 'VIEWER',
}

export enum ViewType {
  FORM = 'FORM',
  GALLERY = 'GALLERY',
  GRID = 'GRID',
  KANBAN = 'KANBAN',
}

export interface GetTableDataInput {
  workspaceId: string;
  tableId: string;
  blockId?: string | null;
  viewId?: string | null;
}

export interface UpdateAppConfigInput {
  blockId: string;
  config: any;
}

export interface WorkspaceIdInput {
  id: string;
  userId?: string | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
